<section class="l-layout__sides w-[100%] py-20 xs:py-24 sm:py-28 lg:py-32 xl:pt-36 flex justify-center">
  <div class="w-full">
    <div class="w-full">
      <slot name="text" />
    </div>
    <div class="w-full">
      <slot name="content" />
    </div>
  </div>
</section>
